exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".arc path {\n  stroke: #fff;\n  stroke-width: 0.75;\n  fill: none;\n  cursor: pointer; }\n\n.arc text {\n  font-size: 12px;\n  font-weight: 500;\n  fill: #fff; }\n\n.legendPie {\n  padding-right: 20px; }\n\n.legendPie-parent {\n  display: grid;\n  grid-template-columns: repeat(4, auto);\n  text-align: left; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/drillDownPie/drillDown.scss
// module id = 611
// module chunks = 0